<template>
  <div :class="componentClassName">
    <div class="o-incoming-call-modal__button">
      <a-button
        id="incomingCall"
        variant="icon"
        color="primary"
        icon="phone-incoming-call"
        icon-color="white"
        @click="handleToggleClick"
      />
      <i v-if="hasNewCall || hasNewOnHold" class="o-incoming-call-modal__indicator-new-call" />
    </div>
    <div v-show="isExpanded" class="o-incoming-call-modal__popup">
      <div class="o-incoming-call-modal__popup-tab-holder">
        <i v-if="hasNewOnHold" class="o-incoming-call-modal__indicator-new-onhold" />
        <m-tab class="o-incoming-call-modal__popup-tab" @change="handleTabChange">
          <loading :active="isCallLoading" :is-full-page="false" width="30" height="30"></loading>
          <a-tab-pane label="着信" name="tab-incoming-call" class="o-incoming-call-modal__incoming-tab">
            <div v-if="!customerInfo" class="o-incoming-call-modal__call-empty">着信はありません</div>
            <a-calling-customer-info
              v-if="customerInfo"
              :title="customerInfo.title"
              :phone-number="customerInfo.phoneNumber"
              :subtitle="customerInfo.subtitle"
              :call-is-incomming="true"
            />
            <div v-if="telNumberInfo || pushNumberSettingName" class="o-incoming-call-modal__response-status">
              <a-calling-response-status v-if="myInfoList.length" :status-list="myInfoList" />
            </div>
            <div v-if="customerInfo" class="o-incoming-call-modal__call-actions">
              <a-button
                variant="icon"
                color="primary-red"
                icon="phone-reject-call"
                icon-color="white"
                @click="handleRejectCallClickAndLoading"
              />
              <a-button
                variant="icon"
                color="green"
                icon="phone-receive-call"
                icon-color="white"
                @click="handleReceiveCallClickAndLoading"
              />
            </div>
            <div v-if="customerInfo && sfContactAvailable && sfAvailable" class="o-incoming-call-modal__sfinfo">
              <div class="o-incoming-call-modal__sfinfo__title">Salesforce取引先責任者</div>
              <div class="o-incoming-call-modal__sfinfo__item">
                <loading :active="isSfLoading" :is-full-page="false" width="25" height="25"></loading>
                <ul
                  v-show="!isSfLoading"
                  :class="hoverClickColor"
                  @mouseover="mouseOverAction"
                  @mouseleave="mouseLeaveAction"
                  @click="handleDescriptionClick"
                >
                  <li class="o-incoming-call-modal__sfinfo__name">{{ sfContactName }}</li>
                  <li class="o-incoming-call-modal__sfinfo__accountname">
                    (マウスオーバーで表示、マウスクリックで表示固定します)
                  </li>
                </ul>
                <div v-if="isSfHover || isSfClick" class="o-incoming-call-modal__sfinfo__description">
                  <a-text v-if="sfTable === 'Case'">過去のSalesforceケース</a-text>
                  <a-text v-if="sfTable === 'Task'">過去のSalesforce活動履歴</a-text>
                  <m-data-table :empty-text="'履歴はありません。'" :fit="true" :data="sfCases">
                    <a-data-table-column label="件名" align="left">
                      <template #default="scope">
                        <a-button :href="scope.row.sfRecordUrl" :target="'_blank'" :type="text" :color="primary">
                          {{ scope.row.sfSubject }}
                        </a-button>
                      </template>
                    </a-data-table-column>
                    <a-data-table-column prop="CreatedDateStr" label="日時" align="left" />
                    <a-data-table-column prop="sfOperator" label="対応オペレータ名" align="left" />
                  </m-data-table>
                </div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane label="保留" name="tab-on-hold" class="o-incoming-call-modal__onhold-tab">
            <ul v-if="onholdList.length > 0" class="o-incoming-call-modal__onhold-list">
              <li v-for="(item, index) in onholdList" :key="index" :class="getOnHoldButtonClassName(item)">
                <a-button
                  variant="icon"
                  icon="phone-call-onhold"
                  :icon-color="item.active ? 'orange' : 'grey'"
                  :disabled="!item.active"
                  @click="handleOnholdButtonClickAndLoading(item.id)"
                />
                <span class="o-incoming-call-modal__onhold-button-label">取次保留 {{ index + 1 }}</span>
              </li>
            </ul>
            <div v-else class="o-incoming-call-modal__onhold-empty">着信はありません</div>
          </a-tab-pane>
        </m-tab>
      </div>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import MTab from '@/components/molecules/tab';
import ATabPane from '@/components/atoms/tab-pane';
import AButton from '@/components/atoms/button';
import ACallingCustomerInfo from '@/components/atoms/calling-customer-info';
import ACallingResponseStatus from '@/components/atoms/calling-response-status';
import { customRequest } from '@/common/customRequest.js';
import Loading from 'vue-loading-overlay';
import { utils } from '@/common/utils.js';

export default {
  name: 'o-incoming-call-modal',
  components: {
    MTab,
    ATabPane,
    AButton,
    ACallingCustomerInfo,
    ACallingResponseStatus,
    Loading,
  },
  mixins: [customRequest, utils],
  props: {
    class: {
      type: String,
      default: '',
    },
    customerInfo: {
      type: Object,
      default: null,
    },
    responseStatusList: {
      type: Array,
      default: new Array(0),
    },
    onholdList: {
      type: Array,
      default: new Array(0),
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      default: null,
    },
    handleIncomingCallTabChange: {
      type: Function,
      default: () => {},
    },
    handleRejectCallClick: {
      type: Function,
      default: () => {},
    },
    handleReceiveCallClick: {
      type: Function,
      default: () => {},
    },
    handleOnholdButtonClick: {
      type: Function,
      default: () => {},
    },
    // indicator
    hasNewCall: {
      type: Boolean,
      default: false,
    },
    hasNewOnHold: {
      type: Boolean,
      default: false,
    },
    sfCases: {
      type: Object,
      default: null,
    },
    sfContactInfo: {
      type: Object,
      default: null,
    },
    pushNumberSettingName: {
      type: String,
      default: '',
    },
    telNumberInfo: {
      type: Object,
      default: null,
    },
  },
  emits: ['modal:displayed'],
  data() {
    return {
      isExpanded: false,
      currentTab: null,
      isExistSfCases: false,
      isSfLoading: true,
      isSfHover: false,
      isSfClick: false,
      sfContactName: '',
      sfContactAvailable: false,
      sfTable: null,
      sfAvailable: false,
      isCallLoading: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-incoming-call-modal');
      return `${baseClassName} ${this.class}`.trim();
    },
    hoverClickColor() {
      if (this.isSfHover && this.isSfClick) {
        return 'o-incoming-call-modal__sfinfo__hoverclick';
      } else if (this.isSfHover) {
        return 'o-incoming-call-modal__sfinfo__hover';
      } else {
        return '';
      }
    },
    myInfoList() {
      const ret = [];
      if (!this.telNumberInfo && !this.pushNumberSettingName) return ret;

      if (this.telNumberInfo && this.telNumberInfo.numberName) {
        ret.push({ label: '番号名称', value: this.collapseText(this.telNumberInfo.numberName, 10) });
      }
      if (this.telNumberInfo && this.telNumberInfo.telNumber) {
        ret.push({ label: '自番号', value: this.telNumberInfo.telNumber });
      }

      if (this.pushNumberSettingName) {
        ret.push({ label: 'プッシュ番号', value: this.collapseText(this.pushNumberSettingName, 10) });
      }
      return ret;
    },
  },
  watch: {
    expanded(val) {
      this.isExpanded = val;
    },
    activeTab(val) {
      this.currentTab = val;
    },
    sfCases(val) {
      if (val) {
        this.initSfCases();
      }
    },
    sfContactInfo(val) {
      if (val) {
        if (val.length > 0) {
          this.sfContactName = this.sfContactInfo[0].Name;
        } else {
          this.sfContactName = '<取引先責任者未登録>';
        }
        this.isSfLoading = false;
      }
    },
    customerInfo(val) {
      if (!val) {
        this.isExistSfCases = false;
      }
    },
    hasNewCall(newVal, oldVal) {
      if (oldVal) {
        this.isExpanded = false;
        this.isCallLoading = false;
      }
    },
    hasNewOnHold(newVal, oldVal) {
      if (oldVal) {
        this.isExpanded = false;
        this.isCallLoading = false;
      }
    },
  },
  async mounted() {
    if (this.expanded) {
      this.isExpanded = this.expanded;
    }
    if (this.activeTab) {
      this.currentTab = this.activeTab;
    }
    this.initSfCases();
    await this.postRequest('/callLogClient/getSfPopupAvailable', {})
      .then(e => {
        if (e.status === 'success') {
          this.sfContactAvailable = e.data.companyInfo.sfContactAvailable;
          this.sfTable = e.data.companyInfo.sfTable;
          this.sfAvailable = e.data.companyInfo.sfAvailable;
        }
      })
      .catch(err => {
        console.error(err);
      });
  },
  methods: {
    handleToggleClick() {
      this.isExpanded = !this.isExpanded;
      this.$emit('modal:displayed', this.isExpanded);
    },
    handleTabChange(tab) {
      this.currentTab = tab;
      this.handleIncomingCallTabChange(tab);
    },
    getOnHoldButtonClassName(item) {
      const className = mapModifiers('o-incoming-call-modal__onhold-button', item.active ? 'active' : 'disabled');
      return className;
    },
    handleRejectCallClickAndLoading() {
      this.handleRejectCallClick();
      this.isCallLoading = true;
    },
    handleReceiveCallClickAndLoading() {
      this.handleReceiveCallClick();
      this.isCallLoading = true;
    },
    handleOnholdButtonClickAndLoading(id) {
      this.handleOnholdButtonClick(id);
      this.isCallLoading = true;
    },
    initSfCases() {
      if (this.sfCases) {
        this.isExistSfCases = true;
        for (const sfCase of this.sfCases) {
          const createdDateObj = new Date(sfCase.sfCreatedDate);
          if (Number.isNaN(createdDateObj.getTime())) {
            sfCase.CreatedDateStr = '';
          } else {
            const createdDateStr = createdDateObj.toLocaleDateString('ja-JP', { timeZone: 'Asia/Tokyo' });
            const createdTimeStr = createdDateObj.toLocaleTimeString('ja-JP', { timeZone: 'Asia/Tokyo' });
            sfCase.CreatedDateStr = createdDateStr + ' ' + createdTimeStr;
          }
        }
      }
    },
    mouseOverAction() {
      this.isSfHover = true;
    },
    mouseLeaveAction() {
      this.isSfHover = false;
    },
    handleDescriptionClick() {
      this.isSfClick = !this.isSfClick;
      if (!this.isSfClick) {
        this.isSfHover = false;
      }
    },
  },
};
</script>
